declare global {
  interface Window {
    __APP_CONFIG__?: {
      apiUrl?: string
      glitchtipDsn?: string
      brand?: string
    }
  }
}

// Populated by /config.js: helm-rendered ConfigMap in k8s, image default in plain docker runs.
const runtimeConfig = window.__APP_CONFIG__ ?? {}

export const API_URL =
  runtimeConfig.apiUrl || import.meta.env.VITE_API_URL || "http://localhost:6500"
export const OSM_TILE_SERVER_CONFIG = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
export const DEBUG = import.meta.env.VITE_DEBUG
  ? JSON.parse(import.meta.env.VITE_DEBUG)
  : false

export const GLITCHTIP_DSN =
  runtimeConfig.glitchtipDsn || import.meta.env.VITE_GLITCHTIP_DSN

export const GLITCHTIP_TRACES_SAMPLE_RATE = import.meta.env
  .VITE_GLITCHTIP_TRACES_SAMPLE_RATE
  ? Number(import.meta.env.VITE_GLITCHTIP_TRACES_SAMPLE_RATE)
  : 0.01

export const BRAND = runtimeConfig.brand || "local"
